<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="margin-bottom-20">
                <h1 class="h2 margin-bottom-20">{{ $t('views.settings.title') }}</h1>
                <a href="" target="_blank" class="hide">Vedi profilo su Marketplace <i class="las la-arrow-right"></i></a>
            </div>
            <table class="table">
                <tbody>
                    <tr>
                        <td width="30%">{{ $t('common.first_name') }}</td>
                        <td>{{getStringOrNA(company.display_name)}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('views.settings.business_email') }}</td>
                        <td>{{getStringOrNA(company.email)}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('views.settings.description') }}</td>
                        <td>{{getStringOrNA(company.description)}}</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default hide">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr class="hide">
                        <td>Logo profilo</td>
                        <td>-</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                    <tr class="hide">
                        <td>Banner profilo</td>
                        <td>-</td>
                        <td class="text-right">
                            <a href="" class="btn btn-default">
                                <i class="las la-edit"></i>
                                {{ $t('common.edit') }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ul class="nav nav-tabs margin-bottom-20">
                <li role="presentation" :class="{ 'active' : selectedTab === TAB.ACCOUNT}">
                    <a href="" role="tab" data-toggle="tab" @click.prevent.stop="accountTabClick">
                        {{ $t('views.settings.account_detail.title') }}
                    </a>
                </li>
                <li role="presentation" :class="{ 'active' : selectedTab === TAB.BANK}">
                    <a href="" role="tab" data-toggle="tab" @click.prevent.stop="bankTabClick">
                        {{ $t('views.settings.account_bank.title') }}
                    </a>
                </li>
                <li role="presentation" :class="{ 'active' : selectedTab === TAB.TAX}">
                    <a href="" role="tab" data-toggle="tab" @click.prevent.stop="taxTabClick">
                        {{ $t('views.settings.tax_detail.title') }}
                    </a>
                </li>
                <li role="presentation" :class="{ 'active' : selectedTab === TAB.TEAM}">
                    <a href="" role="tab" data-toggle="tab" @click.prevent.stop="teamTabClick">
                        {{ $t('views.settings.team.title') }}
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.ACCOUNT}" id="account">
                    <h3 class="margin-bottom-20">{{ $t('views.settings.account_detail.title') }}</h3>
                    <RespiraPayNotActivated v-if="!company.stripe_connected_account" />
                    <div v-else>
                        <h4>{{ $t('views.settings.account_detail.title_info') }}</h4>
                        <table class="table">
                            <tbody>
                            <tr>
                                <td width="35%">{{ $t('views.settings.account_detail.business_name') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account.business_profile.name)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('views.settings.account_detail.telephone_number') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account.company.phone)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('views.settings.account_detail.registered_office') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account.company.address.line1)}}, {{getStringOrNA(company.stripe_connected_account.company.address.postal_code)}} {{getStringOrNA(company.stripe_connected_account.company.address.city)}} ({{getStringOrNA(company.stripe_connected_account.company.address.state)}})</td>
                            </tr>
                            <tr>
                                <td>{{ $t('views.settings.account_detail.website') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account.business_profile.url)}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <h4>{{ $t('views.settings.account_detail.attorney_title') }}</h4>
                        <table class="table">
                            <tbody>
                            <tr>
                                <td width="35%">{{ $t('common.first_name') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account_person.first_name)}} {{getStringOrNA(company.stripe_connected_account_person.last_name)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('common.phone') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account_person.phone)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('common.email') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account_person.email)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('common.birthday') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account_person.dob.day)}}/{{getStringOrNA(company.stripe_connected_account_person.dob.month)}}/{{getStringOrNA(company.stripe_connected_account_person.dob.year)}}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('views.settings.account_detail.attorney_address') }}</td>
                                <td>{{getStringOrNA(company.stripe_connected_account_person.address.line1)}}, {{getStringOrNA(company.stripe_connected_account_person.address.postal_code)}} {{getStringOrNA(company.stripe_connected_account_person.address.city)}} ({{getStringOrNA(company.stripe_connected_account_person.address.state)}})</td>
                            </tr>
                            <tr>
                                <td>{{ $t('views.settings.account_detail.attorney_identity_doc') }}</td>
                                <td>
                                    <span v-if="company.stripe_connected_account_person.verification.status==='verified'" class="badge">{{ $t('common.verified') }}</span>
                                    <span v-else class="badge">{{ $t('common.not_verified') }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <a class="btn btn-default" :href="$t('views.settings.account_detail.mail')" target="_blank"><i class="las la-envelope"></i>{{ $t('views.settings.account_detail.tell_update') }}</a>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.BANK}" id="bank">
                    <h3 class="margin-bottom-20">{{ $t('views.settings.account_bank.title') }}</h3>
                    <RespiraPayNotActivated v-if="!company.stripe_connected_account" />
                    <div v-else>
                        <table class="table">
                        <thead>
                            <tr>
                                <th>{{ $t('views.settings.account_bank.bank') }}</th>
                                <th>{{ $t('views.settings.account_bank.account_number') }}</th>
                                <th>{{ $t('views.settings.account_bank.currency') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="account_ext in company.stripe_connected_account.external_accounts.data" v-bind:key="account_ext.id">
                                <td>{{account_ext.bank_name}}</td>
                                <td>••••{{account_ext.last4}} / {{account_ext.routing_number}}</td>
                                <td><span class="badge" style="text-transform: uppercase">{{account_ext.currency}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                        <a class="btn btn-default" :href="$t('views.settings.account_bank.mail')" target="_blank"><i class="las la-envelope"></i>{{ $t('views.settings.account_bank.tell_update') }}</a>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.TAX}" id="tax">
                    <h3 class="margin-bottom-20">{{ $t('views.settings.tax_detail.title') }}</h3>
                    <RespiraPayNotActivated v-if="!company.stripe_connected_account" />
                    <div v-else>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{ $t('views.settings.tax_detail.company_type') }}</th>
                                    <th>{{ $t('views.settings.tax_detail.business_name') }}</th>
                                    <th>{{ $t('views.settings.tax_detail.vat') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{stripeCompanyBusinessTypeStr}}</td>
                                    <td>{{getStringOrNA(company.stripe_connected_account.company.name)}}</td>
                                    <td>{{getStringOrNA(company.fiscal_or_vat)}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <a class="btn btn-default" :href="$t('views.settings.tax_detail.mail')"  target="_blank"><i class="las la-envelope"></i>{{ $t('views.settings.tax_detail.tell_update') }}</a>
                    </div>
                </div>
                <div role="tabpanel" class="tab-pane padding-top-20" :class="{ 'active' : selectedTab === TAB.TEAM}" id="team">
                    <h3 class="margin-bottom-20">{{ $t('views.settings.team.title') }}</h3>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{ $t('common.first_name') }}</th>
                                <th>{{ $t('views.settings.team.role') }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="clientAdmin in clientAdmins" v-bind:key="clientAdmin.id">
                                <td><span class="bold">{{clientAdmin.full_name}}</span><br/>{{clientAdmin.email}}</td>
                                <td>{{ $t('views.settings.team.admin') }} <span v-if="clientAdmin.role === CLIENT_ADMIN_ROLE.SUPER_ADMIN">({{ $t('views.settings.team.owner') }})</span></td>
                                <td class="text-right">
                                    <a href="" class="btn btn-default hide">
                                        <i class="las la-edit"></i>
                                        {{ $t('common.edit') }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {getAllClientAdmin, getCompanyInfo} from "../api";
    import RespiraPayNotActivated from "../components/settings/RespiraPayNotActivated";
    import {Utils} from "../common/utils";
    import {CLIENT_ADMIN_ROLE} from "../common/constants";
    import i18n from "../i18n"

    export default {
        title: i18n.t('views.settings.title'),
        name: "Settings",
        components: { ContainerWithMenu, SpinnerLoader, RespiraPayNotActivated },
        data: function () {
            return {
                loading: false,
                selectedTab: 0,
                TAB : {
                    ACCOUNT: 0,
                    BANK: 1,
                    TAX: 2,
                    TEAM: 3
                },
                CLIENT_ADMIN_ROLE: CLIENT_ADMIN_ROLE,
                company: {},
                clientAdmins: []
            }
        },
        async mounted() {
            this.loading = true;
            this.errorMessage = "";
            try {
                this.company = await getCompanyInfo();
                this.loading = false;
            } catch (e) {
                this.loading = false;

            }
        },
        computed: {
            stripeCompanyBusinessTypeStr() {
                return Utils.getStringStripeBusinessType(this.company.stripe_connected_account.business_type)
            }
        },
        methods: {
            getStringOrNA(text) {
                return Utils.getStringOrNA(text)
            },
            async getClientAdmins() {
                this.loading = true;
                try {
                    this.clientAdmins = await getAllClientAdmin();
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            accountTabClick() {
                this.selectedTab = this.TAB.ACCOUNT;
            },
            bankTabClick() {
                this.selectedTab = this.TAB.BANK;
            },
            taxTabClick() {
                this.selectedTab = this.TAB.TAX;
            },
            teamTabClick() {
                this.selectedTab = this.TAB.TEAM;
                this.getClientAdmins();
            }
        }
    };
</script>
